import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field, SubmissionError, formValueSelector } from 'redux-form';
import { RenderHTMLSelect, RenderInputWithDiv, RenderNumberInput } from '../../../component/formInput';

var _ = require("lodash");
const selector = formValueSelector("ProductModal")

class ProductModal extends React.Component {
  constructor(props) {
      super(props);
      this.state = {

      }

  }

  componentDidMount() {
    const { productObj, loadProductAsync } = this.props;
    if(productObj) {
      loadProductAsync(productObj.id);
    }
  }

  componentWillUnmount() {
    const { clearProductDataValue } = this.props;
    clearProductDataValue();
  }
  
  submit = (values) => {
    const { onHide, invoice_code, productObj } = this.props;
    let api_type = "/admin/api/product/create";
    let attrs = {
      ...values
    }
    // Trường hợp update
    if(productObj && productObj.id) {
      api_type = "/admin/api/product/update";
      attrs.id = productObj.id;
    }
    return axios({
      method: 'post',
      url: window.api_url + api_type,
      data: attrs,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        onHide();
      }else {
        throw new SubmissionError(response.data.error);
      }
    })
  }
  
  render() {
    const { handleSubmit, submitting, onHide, productObj, product_type_selected } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    const title = productObj ? "Chỉnh sửa" : "Thêm mới"
    const product_type_options = [
      {label: "VPS", value: "VPS"},
      {label: "Cloud Server Pro", value: "CLOUD_SERVER_PRO"},
      {label: "VN Domain", value: "VN_DOMAIN"},
      {label: "COM Domain", value: "COM_DOMAIN"},
      {label: "Linux Hosting", value: "LINUX_HOSTING"},
      {label: "Windows Hosting", value: "WINDOW_HOSTING"},
      {label: "Email", value: "EMAIL"},
      {label: "SSL", value: "SSL"},
      {label: "Tổng Đài Taduphone", value: "TADU_PHONE"},
      {label: "Hóa Đơn Điện Tử", value: "TADU_INVOICE"},
      {label: "Chữ Ký Số", value: "DIGITAL_SIGNATURE"},
      {label: "IP Addon", value: "IP"},
      {label: "Whois Addon", value: "WHOIS_PRIVACY"},
    ]
    
    const newModal = <div style={{ width: '30%' }}>
    <Modal
      {...modalConfig}
      aria-labelledby="contained-modal-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-sm"><center>{title}</center> </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form-horizontal" role="form" onSubmit={handleSubmit(this.submit)}>
          <Field name="name" label="Tên" placeholder="Vui lòng nhập..." component={RenderInputWithDiv}></Field>
          <Field name="code" label="Mã" placeholder="Vui lòng nhập..." component={RenderInputWithDiv}></Field>
          <Field name="product_type" label="Loại" options={product_type_options} component={RenderHTMLSelect}></Field>
          <Field name="level" label="Level" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          {["VPS", "CLOUD_SERVER_PRO"].includes(product_type_selected) && <React.Fragment>
            <Field name="cpu" label="Cpu" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
            <Field name="ram" label="Ram" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
            <Field name="hdd" label="HDD" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          </React.Fragment>}
          <Field name="point" label="Point" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          <div className="text-right">
            <a onClick={()=>onHide()} className={"btn"}>
              Đóng
            </a>
            <button type="submit" className={"btn bg-blue btn-primary " + (submitting ? "disabled" : "")}>
              Lưu <i className="icon-arrow-right14 position-right"></i>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
    </div>
    return newModal;
  }
};
const mapState = (state, props) => ({
  initialValues: {
    ...state.product.data
  },
  product_type_selected: selector(state, "product_type"),
});

const mapDispatch = dispatch => ({
  loadProductAsync: (product_id) => dispatch.product.loadProductAsync(product_id),
  clearProductDataValue: () => dispatch.product.clearProductDataValue()
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ProductModal',
    destroyOnUnmount: true,
    enableReinitialize: true
  })(withRouter(ProductModal))));
